// eslint-disable-next-line @typescript-eslint/no-var-requires
const { yupResolver } = require('@hookform/resolvers/yup');
import { FieldValues, ResolverOptions, ResolverResult, UnpackNestedValue } from 'react-hook-form';
import * as yup from 'yup';
import { REG_CODE_MIN_LENGTH, REG_CODE_REGEX } from 'constants/index';

const RegCodeSchema = (): (<TFieldValues extends FieldValues, TContext>(
  values: UnpackNestedValue<TFieldValues>,
  context: TContext | undefined,
  options: ResolverOptions<TFieldValues>,
) => Promise<ResolverResult<TFieldValues>>) =>
  yupResolver(
    yup
      .object()
      .shape({
        regCode: yup
          .string()
          .nullable()
          .required('Reg code is required')
          .min(REG_CODE_MIN_LENGTH, `Code must be at least ${REG_CODE_MIN_LENGTH} characters`)
          .matches(REG_CODE_REGEX, 'Code must only contain letters and numbers'),
      })
      .required(),
  );

export default RegCodeSchema;
